'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.getBackgroundCarouselImages = getBackgroundCarouselImages;

var _Product = require('./Product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BG_CAROUSEL_PATH = '/backgrounds/carousel';

var IMAGES = (0, _defineProperty3.default)({}, _Product.PRODUCT_NAMES.Qello, {
  bg_carousel: ['1.png', '2.png', '3.png', '4.png', '5.png', '6.png', '7.png']
});

function getImage(basePath, productName, imageName) {
  var resource = void 0;
  var path = basePath + '/' + productName.toLowerCase() + '/' + imageName;
  try {
    resource = require('../../res/images' + path);
  } catch (ex) {
    console.error('Failed to get path: \'../../res/images' + path + '\'');
  }
  return resource;
}

function getImages(basePath, productName, imageNames) {
  return imageNames.map(function (name) {
    return getImage(basePath, productName, name);
  }).filter(function (domElement) {
    return domElement;
  });
}

function fetchBackgroundCarouselImages(productName, imageNames) {
  return getImages(BG_CAROUSEL_PATH, productName, imageNames);
}

function getBackgroundCarouselImages(product) {
  var images = void 0;

  switch (product) {
    case _Product.PRODUCT_NAMES.Qello:
      {
        var imageNames = IMAGES[product].bg_carousel;
        images = fetchBackgroundCarouselImages(product, imageNames);
        break;
      }
    default:
      {
        images = [];
      }
  }

  return images;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ImageRetriever.js
// module id = 2031
// module chunks = 0